import { render, staticRenderFns } from "./StockTransferCreate.vue?vue&type=template&id=e54144a8&scoped=true&"
import script from "./StockTransferCreate.vue?vue&type=script&lang=js&"
export * from "./StockTransferCreate.vue?vue&type=script&lang=js&"
import style0 from "./StockTransferCreate.vue?vue&type=style&index=0&id=e54144a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54144a8",
  null
  
)

export default component.exports